import React, { useState } from 'react';
import './Contact.css';
import { contactService } from '../services/contactService';
import { toSentenceCase } from '../utils/textUtils';

function Contact() {
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    sujet: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await contactService.submit(formData);
      setSuccess(true);
      // Réinitialiser le formulaire
      setFormData({
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        sujet: '',
        message: ''
      });
      
      // Masquer le message de succès après 5 secondes
      setTimeout(() => setSuccess(false), 5000);
    } catch (err) {
      setError(toSentenceCase('Une erreur est survenue. Veuillez réessayer.'));
      console.error('Erreur lors de l\'envoi du message:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact section" id="contact">
      <div className="container">
        <div className="section-header-center">
          <h2 className="section-title">{toSentenceCase("Contactez-nous")}</h2>
          <p className="section-subtitle">
            {toSentenceCase("Une question, une idée ou un besoin ? Notre équipe est toujours disponible pour vous répondre.")}
          </p>
        </div>

        <div className="contact-grid">
          {/* Photo de contact */}
          <div className="contact-image-section">
            <img 
              src="/images/parent-eleve-contact.png" 
              alt="Parent d'élève et élève - GSU Les Palmiers" 
              className="contact-image"
            />
            <div className="gsu-badge-overlay">
              <img src="/images/logo-gsu.png" alt="Logo GSU" className="gsu-badge-logo" />
              <span>GSU Les Palmiers</span>
            </div>
          </div>

          {/* Formulaire de contact */}
          <div className="form-section">
            <h2>{toSentenceCase("Contactez-nous")}</h2>
            <p className="form-subtitle">
              {toSentenceCase("Une question ? Nous sommes là pour vous accompagner.")}
            </p>

            {success && (
              <div className="alert alert-success">
                {toSentenceCase("Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.")}
              </div>
            )}

            {error && (
              <div className="alert alert-error">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <input
                  type="text"
                  name="nom"
                  placeholder="Nom"
                  value={formData.nom}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
                <input
                  type="text"
                  name="prenom"
                  placeholder="Prénom"
                  value={formData.prenom}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>

              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
              />

              <input
                type="tel"
                name="telephone"
                placeholder="Téléphone"
                value={formData.telephone}
                onChange={handleChange}
                disabled={loading}
              />

              <input
                type="text"
                name="sujet"
                placeholder="Sujet"
                value={formData.sujet}
                onChange={handleChange}
                required
                disabled={loading}
              />

              <textarea
                name="message"
                placeholder="Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
                disabled={loading}
              ></textarea>

              <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
                {loading ? toSentenceCase('Envoi en cours...') : toSentenceCase('Envoyer le message')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
